import { Component, OnInit } from '@angular/core';
import {Order} from '../../models/order.model';
import {OrderService} from '../../account/orders/shared/order.service';
import {Subscription} from 'rxjs';
import jsPDF from 'jspdf';




@Component({
  selector: 'app-order-admin',
  templateUrl: './order-admin.component.html',
  styleUrls: ['./order-admin.component.scss']
})



export class OrderAdminComponent implements OnInit {
  public orders: Order[];
  private ordersSubscription: Subscription;
  selectedOrder: Order | null = null;
  isEditing = false;
  isCreating = false;
  showInvoiceModal = false;

  constructor(public orderService: OrderService) {}

  ngOnInit() {
    this.loadOrders();
  }

  loadOrders(): void {
    this.ordersSubscription = this.orderService
      .getAllOrders()
      .subscribe((orders: Order[]) => {
        console.log('Orders fetched:', orders);
        if (orders) {
          this.orders = orders.reverse();
        }
      });
  }

  ngOnDestroy() {
    this.ordersSubscription.unsubscribe();
  }

  selectOrder(order: Order): void {
    this.selectedOrder = { ...order };
    this.isEditing = true;
    this.isCreating = false;
  }

  openOrderDetails(order: Order): void {
    this.selectedOrder = { ...order };
    this.showInvoiceModal = true;
  }

  closeInvoiceModal(): void {
    this.showInvoiceModal = false;
    this.selectedOrder = null;
  }



  handleModalClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.classList.contains('modal')) {
      this.closeInvoiceModal();
    }
  }

  downloadInvoice(): void {
    if (this.selectedOrder) {
      const doc = new jsPDF();
      const margin = 20;
      let y = 20;

      // Header
      doc.setFont('times', 'bold');
      doc.setFontSize(20);
      doc.setTextColor(212, 160, 23); // Gold color (#D4A017)
      doc.text(`Invoice #${this.selectedOrder.number}`, margin, y);
      y += 15;

      // Customer Information
      doc.setFont('times', 'bold');
      doc.setFontSize(14);
      doc.setTextColor(0, 0, 0); // Black
      doc.text('Customer Information', margin, y);
      y += 10;

      doc.setFont('times', 'normal');
      doc.setFontSize(12);
      doc.text(`Name: ${this.selectedOrder.customer.firstname} ${this.selectedOrder.customer.lastname}`, margin, y);
      y += 7;
      doc.text(`Address: ${this.selectedOrder.customer.address1}, ${this.selectedOrder.customer.city}, ${this.selectedOrder.customer.country} ${this.selectedOrder.customer.zip}`, margin, y);
      y += 7;
      doc.text(`Phone: ${this.selectedOrder.customer.phone}`, margin, y);
      y += 7;
      if (this.selectedOrder.customer.email) {
        doc.text(`Email: ${this.selectedOrder.customer.email}`, margin, y);
        y += 7;
      }
      y += 10;

      // Order Details
      doc.setFont('times', 'bold');
      doc.setFontSize(14);
      doc.text('Order Details', margin, y);
      y += 10;

      doc.setFont('times', 'normal');
      doc.setFontSize(12);
      doc.text(`Order Date: ${new Date(this.selectedOrder.date).toLocaleString()}`, margin, y);
      y += 7;
      doc.text(`Status: ${this.selectedOrder.status}`, margin, y);
      y += 7;
      doc.text(`Payment Method: ${this.selectedOrder.paymentMethod || 'N/A'}`, margin, y);
      y += 7;
      doc.text(`Shipping Method: ${this.selectedOrder.shippingMethod || 'N/A'}`, margin, y);
      y += 10;

      // Items Table
      doc.setFont('times', 'bold');
      doc.setFontSize(14);
      doc.text('Items', margin, y);
      y += 10;

      // Table Header
      doc.setFont('times', 'bold');
      doc.setFontSize(12);
      doc.text('Product', margin, y);
      doc.text('Quantity', margin + 80, y);
      doc.text('Unit Price', margin + 110, y);
      doc.text('Total', margin + 150, y);
      y += 5;
      doc.line(margin, y, 190, y); // Horizontal line
      y += 10;

      // Table Rows
      doc.setFont('times', 'normal');
      this.selectedOrder.items.forEach(item => {
        const productName = `${item.product.name}${item.option ? ` (${item.option.label})` : ''}`;
        const description = item.product.description ? ` (${item.product.description})` : '';
        const wrappedProduct = doc.splitTextToSize(productName + description, 70); // Wrap text if too long
        const lineHeight = wrappedProduct.length * 7;

        wrappedProduct.forEach((line: string, index: number) => {
          doc.text(line, margin, y + index * 7);
        });
        doc.text(item.quantity.toString(), margin + 80, y);
        doc.text((item.price*13).toLocaleString('en-US', { style: 'currency', currency: 'MAD' }), margin + 110, y);
        doc.text((item.price * item.quantity*13).toLocaleString('en-US', { style: 'currency', currency: 'MAD' }), margin + 150, y);
        y += lineHeight + 5;
      });

      y += 5;
      doc.line(margin, y, 190, y); // Horizontal line
      y += 10;

      // Total
      doc.setFont('times', 'bold');
      doc.setTextColor(212, 160, 23); // Gold color
      doc.text(`Total: ${this.selectedOrder.total.toLocaleString('en-US', { style: 'currency', currency: 'MAD' })}`, margin + 150, y, { align: 'right' });

      // Save PDF
      doc.save(`Invoice_${this.selectedOrder.number}.pdf`);
    }
  }



  createNewOrder(): void {
    this.selectedOrder = {
      number: '',
      date: new Date().toISOString(),
      customer: {
        address1: '',
        address2: '',
        city: '',
        company: '',
        country: '',
        email: '',
        firstname: '',
        lastname: '',
        location: '',
        note: '',
        phone: '',
        zip: 0
      },
      items: [],
      paymentMethod: '',
      shippingMethod: '',
      status: 'In Progress',
      total: 0
    };
    this.isCreating = true;
    this.isEditing = false;
  }

  addItem(): void {
    if (this.selectedOrder) {
      this.selectedOrder.items.push({
        price: 0,
        priceIndex: 0,
        quantity: 1,
        product: {
          categories: {},
          currentRating: 0,
          date: new Date().toISOString(),
          description: '',
          familles: {},
          id: Date.now(),
          imageURLs: [],
          marque: '',
          name: '',
          price: 0,
          priceNormal: 0,
          reduction: 0,
          sale: false,
          sku: '',
          sousFamilles: {},
          url: ''
        }
      });
    }
  }

  removeItem(index: number): void {
    if (this.selectedOrder) {
      this.selectedOrder.items.splice(index, 1);
      this.calculateTotal();
    }
  }

  calculateTotal(): void {
    if (this.selectedOrder) {
      this.selectedOrder.total = this.selectedOrder.items.reduce(
        (sum, item) => sum + (item.price * item.quantity),
        0
      );
    }
  }

  saveOrder(): void {
    if (this.selectedOrder) {
      this.calculateTotal();
     /* if (this.isCreating) {
        this.orderService.createOrder(this.selectedOrder).subscribe(() => {
          this.loadOrders();
          this.resetForm();
        });
      } else {
        this.orderService.updateOrder(this.selectedOrder).subscribe(() => {
          this.loadOrders();
          this.resetForm();
        });
      }*/
    }
  }

  deleteOrder(orderNumber: string): void {
    if (confirm('Are you sure you want to delete this order?')) {
      // this.orderService.deleteOrder(orderNumber).subscribe(() => {
      //   this.loadOrders();
      //   this.resetForm();
      // });
    }
  }

  resetForm(): void {
    this.selectedOrder = null;
    this.isEditing = false;
    this.isCreating = false;
    this.showInvoiceModal = false;
  }
}
